<div class="skeleton-item">
    <!-- Eyebrow: ícone do tipo + rótulo -->
    <div class="row-top">
        <span class="sk eyebrow-icon"></span>
        <span class="sk eyebrow-text"></span>
    </div>

    <!-- Conteúdo -->
    <span class="sk line line-1"></span>
    <span class="sk line line-2"></span>
    <span class="sk line line-3"></span>
</div>
